"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _reactFeather = require("react-feather");

var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));

var _slice = require("@lce/slice");

var _i18n = require("@lce/i18n");

var _api = require("@lce/api");

var _Links = _interopRequireDefault(require("../Links"));

var _Links2 = require("../Links.data");

var _sliceIcon = _interopRequireDefault(require("../assets/sliceIcon.png"));

var Styled = _interopRequireWildcard(require("./Modal.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Button = function Button(_a) {
  var onClick = _a.onClick,
      children = _a.children,
      props = (0, _tslib.__rest)(_a, ["onClick", "children"]);
  return _react["default"].createElement(Styled.Button, (0, _tslib.__assign)({
    "aria-label": "Account Menu",
    id: "header__hamburger-button",
    onClick: onClick
  }, props), children);
}; // eslint-disable-next-line max-lines-per-function


var Modal = function Modal(_a) {
  var isOpen = _a.isOpen,
      setIsOpen = _a.setIsOpen;
  var t = (0, _i18n.useTranslation)()[0];
  var isAuthenticated = (0, _api.useAuthenticated)();
  var account = (0, _api.useAccount)().data;
  var name = account === null || account === void 0 ? void 0 : account.firstName;

  var handleOnClose = function handleOnClose() {
    var _a;

    setIsOpen(false);
    (_a = document.getElementById('header__hamburger-button')) === null || _a === void 0 ? void 0 : _a.focus();
  };

  var handleOnOpen = function handleOnOpen() {
    return setIsOpen(true);
  };

  var links = isAuthenticated ? _Links2.modalLinks : _Links2.guestLinks;
  return isOpen ? _react["default"].createElement(_slice.Layer, {
    closeOnClickOutside: true,
    isOpen: isOpen,
    lockBodyScroll: true,
    onClose: handleOnClose,
    overlay: false
  }, _react["default"].createElement(_focusTrapReact["default"], {
    active: isOpen,
    focusTrapOptions: {
      allowOutsideClick: true
    }
  }, _react["default"].createElement(Styled.Modal, {
    "aria-label": "Account Menu-Links",
    "aria-modal": "true",
    role: "dialog"
  }, _react["default"].createElement(Styled.ButtonContainer, null, _react["default"].createElement(Button, {
    "aria-label": "Close Account Menu",
    "data-testid": "header__close",
    onClick: handleOnClose
  }, _react["default"].createElement(_reactFeather.X, {
    size: 44
  }))), _react["default"].createElement(Styled.Content, {
    "data-testid": "header__hamburger-account"
  }, _react["default"].createElement(Styled.GreetingParent, null, _react["default"].createElement(Styled.AccountIcon, {
    src: _sliceIcon["default"]
  }), _react["default"].createElement(Styled.Name, null, t('Header.AccountLinks.Greeting') + " " + (name ? name : t('Header.AccountLinks.Guest')))), links && _react["default"].createElement(_Links["default"], {
    handleOnClose: handleOnClose,
    linkArr: links
  }))))) : _react["default"].createElement(Button, {
    "data-testid": "header__hamburger-button",
    onClick: handleOnOpen
  }, _react["default"].createElement(_reactFeather.Menu, {
    size: 44
  }));
};

var _default = Modal;
exports["default"] = _default;